



























































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Client from "@/store/entities/client";
import TabService from "./tab-service.vue";
import AddressModal from "../../components/address-modal.vue";
import Address from "../../../store/entities/address";
import _ from "lodash";
import util from "../../../lib/util";
import AppConsts from "@/lib/appconst";
@Component({
  components: { AddressModal, TabService },
})
export default class CreateClient extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  clientAddress: Address = null;
  selectedAddress: Address = new Address();
  model: Client = new Client();
  isUpload: boolean = false;
  fullUrlImage: string = "";
  type: string;
  id: string;
  validFullAddress = false;

  notificationTypes: [] = [];
  objectLoading: boolean = false;
  employeeIdFilter: number = 0;
  notificationTypeCodeFilter: string = "";
  employeesFilter: [] = [];
  employeeIdConfig: number = 0;
  employeeConfig: any;
  notificationTypeCodeConfig: string = "";
  notificationTypeConfig: any;
  employeesConfig: [] = [];
  listConfig: any[] = [];
  modeAddConfig: boolean = false;

  clientTypes = [
    {
      id: "ORG",
      name: this.L("ORG"),
    },
    {
      id: "INDV",
      name: this.L("INDV"),
    },
  ];
  spinShow: boolean = false;

  updateAddress() {
    const { fullAddress } = this.selectedAddress;
    this.model = { ...this.model, fullAddress };
    if (this.isUpdate) {
      if (
        _.isNil(this.clientAddress) ||
        util.addressDiff(this.clientAddress, this.selectedAddress)
      ) {
        var address = this.selectedAddress;
        this.model = { ...this.model, address };
      } else {
        this.model.address = null;
      }
    }
  }

  getShippingServices() {
    this.$store.dispatch({
      type: "client/getShippingServices",
    });
  }

  getExtraServices() {
    this.$store.dispatch({
      type: "client/getExtraServices",
    });
  }

  getAssetTypeServices() {
    this.$store.dispatch({
      type: "client/getAssetTypeServices",
    });
  }

  openModalAddress() {
    this.addressModalShow = true;
  }
  callbackCheckFullAddress() {
    this.validFullAddress = true;
  }
  get isUpdate() {
    return !(this.type == "view");
  }
  get isCreate() {
    return this.isUpdate && this.type != "edit";
  }
  async created() {
    try {
      this.spinShow = true;

      this.id = this.$root.$router.currentRoute.params.id;
      this.type = this.$root.$router.currentRoute.params.type;
      switch (this.type) {
        case "create":
          this.isUpload = false;
          break;
        case "edit":
          this.isUpload = false;
          await this.getClientById(this.id);
          break;
        case "view":
          this.isUpload = true;
          await this.getClientById(this.id);
          break;
      }

      this.getAssetTypeServices();
      this.getShippingServices();
      this.getExtraServices();
      await this.$store
        .dispatch({
          type: "masterData/getNotificationTypes",
        })
        .then((res) => {
          this.getNotificationType(res);
        });
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  getNotificationType(re) {
    re.unshift({
      id: AppConsts.allItemValue,
      name: this.L(AppConsts.All),
    });
    this.notificationTypes = re;
  }

  async getClientById(id: string) {
    await this.$store
      .dispatch({
        type: "client/get",
        id: this.id,
      })
      .then((res) => {
        this.model = res;
        this.fullUrlImage = Util.getAppUrlImage(res.logoUrl);
        this.selectedAddress = res.address;
        this.clientAddress = { ...res.address };
        this.model.address = null;
      });
  }

  save() {
    (this.$refs.form as any).validate(async (valid: boolean) => {
      if (valid) {
        this.validateFullAddress(
          this.clientRules,
          "",
          this.callbackCheckFullAddress
        );
        if (this.validFullAddress) {
          const { extraServices, assetTypeServices, shippingServices } =
            this.$store.state.client.editClient;

          if (this.modeAddConfig) {
            this.model.createNotificationConfigs = this.listConfig;
          }

          this.model = {
            ...this.model,
            extraServices,
            assetTypeServices,
            shippingServices,
          };
          const t = this.type == "edit" ? "client/update" : "client/create";
          this.spinShow = true;

          this.$store
            .dispatch({
              type: t,
              data: this.model,
            })
            .then((res) => {
              this.cancel();
            })
            .finally(() => {
              this.spinShow = false;
            });
        }
      }
    });
  }
  cancel() {
    (this.$refs.form as any).resetFields();
    this.$root.$router.push({ name: "client" });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (
      fileExt === "jpep" ||
      fileExt === "jpg" ||
      fileExt === "png" ||
      fileExt === "gif" ||
      fileExt === "jfif"
    ) {
      let data = new FormData();
      data.append("file", file);

      this.$store.dispatch("product/uploadProductImage", data).then((res) => {
        this.model = { ...this.model, logoUrl: res };
        this.isUpload = true;
        this.fullUrlImage = Util.getAppUrlImage(res);
      });
    }

    return false;
  }
  validateFullAddress(rule, value, callback) {
    if (_.isNil(this.model.fullAddress) || _.isEmpty(this.model.fullAddress)) {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, this.L("Address")))
      );
    } else {
      callback();
    }
  }
  clientRules = {
    id: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Code")),
        trigger: "blur",
      },
    ],
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Name")),
        trigger: "blur",
      },
    ],
    shortName: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("ShortName")),
        trigger: "blur",
      },
    ],
    type: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ClientType")
        ),
        trigger: "blur",
      },
    ],
    contactName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ContactName")
        ),
        trigger: "blur",
      },
    ],
    contactPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ContactPhone")
        ),
        trigger: "blur",
      },
    ],
    email: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Email")),
        trigger: "blur",
      },
      { type: "email" },
    ],
    tax: [
      {
        required: true,
        message: this.L("Error.RequiredField0", undefined, this.L("Tax")),
        trigger: "blur",
      },
    ],
    fullAddress: [
      {
        required: true,
        validator: this.validateFullAddress,
        trigger: "change",
      },
    ],
  };

  //Config
  searchEmployeesOfClientConfig_OnPress = _.debounce(
    this.searchEmployeesOfClientConfig,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployeesOfClientConfig(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    const request = {
      clientCode: this.model.id,
      keyword,
    };
    await this.$store
      .dispatch({
        type: "user/searchEmployeesOfClient",
        data: request,
      })
      .then((res) => {
        this.objectLoading = false;
        this.employeesConfig = res;
      });
  }

  changeEmployeeConfig(id) {
    this.employeeConfig = _.find(this.employeesConfig, function (obj) {
      if (obj.id === id) {
        return true;
      }
    });
  }

  changeNotificationTypeConfig(id) {
    this.notificationTypeConfig = _.find(
      this.notificationTypes,
      function (obj) {
        if (obj.id === id) return true;
      }
    );
  }

  async onAddNewConfig() {
    if (!this.modeAddConfig) {
      this.modeAddConfig = true;
      this.listConfig = [];
    }

    if (this.employeeIdConfig === 0 || this.notificationTypeCodeConfig === "")
      return;

    const userId = this.employeeIdConfig;
    const type = this.notificationTypeCodeConfig;
    const eixtConfig = _.find(this.listConfig, function (obj) {
      if (
        obj.object.toString() === userId.toString() &&
        obj.notificationTypecode === type
      )
        return obj;
    });
    if (!_.isNil(eixtConfig) && !_.isEmpty(eixtConfig)) {
      this.$Message.error("Cấu hình thông báo đối tượng trên đã tồn tại");
      return;
    }

    await this.$store
      .dispatch({
        type: "client/checkNotificationConfigExisted",
        data: {
          object: this.employeeIdConfig,
          objectType: "USER",
          NotificationTypecode: this.notificationTypeCodeConfig,
        },
      })
      .then((res) => {
        if (res) {
          this.$Message.error("Cấu hình thông báo đối tượng trên đã tồn tại");
          return;
        }
        const newConfig = {
          id: 0,
          object: this.employeeConfig.id,
          objectType: "USER",
          notificationTypecode: this.notificationTypeConfig.id,
          objectName: `${this.employeeConfig.userName} - ${this.employeeConfig.name}`,
          notificationTypeName: this.notificationTypeConfig.name,
        };

        this.listConfig.unshift(newConfig);
      });
  }

  async onDeleteConfig(id: number, index: number) {
    if (id === 0) {
      this.listConfig.splice(index, 1);
    } else {
      this.$Modal.confirm({
        title: "Xác nhận xóa cấu hình thông báo đã lưu",
        content: "Xóa cấu hình thông báo đã lưu",
        okText: Util.getYesText(),
        cancelText: Util.getNoText(),
        onOk: async () => {
          await this.$store
            .dispatch({
              type: "client/deleteNotificationConfig",
              data: {
                id,
              },
            })
            .then((res) => {
              if (res) this.listConfig.splice(index, 1);
            });
        },
      });
    }
  }
  async onDeleteAllConfig() {
    if (this.modeAddConfig) {
      this.listConfig = [];
      return;
    } else {
      this.$Modal.confirm({
        title: "Xác nhận xóa tất cả cấu hình thông báo đã lưu",
        content: "Xóa tất cả cấu hình thông báo đã lưu",
        okText: Util.getYesText(),
        cancelText: Util.getNoText(),
        onOk: async () => {
          await this.$store
            .dispatch({
              type: "client/deleteAllNotificationConfig",
              data: {
                clientCode: this.model.id,
              },
            })
            .then((res) => {
              if (res) this.listConfig = [];
            });
        },
      });
    }
  }

  //Filter
  searchEmployeesOfClient_OnPress = _.debounce(
    this.searchEmployeesOfClient,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );

  async searchEmployeesOfClient(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    const request = {
      clientCode: this.model.id,
      keyword,
    };
    await this.$store
      .dispatch({
        type: "user/searchEmployeesOfClient",
        data: request,
      })
      .then((res) => {
        this.objectLoading = false;
        this.employeesFilter = res;
      });
  }

  async searchNotificationConfig() {
    this.modeAddConfig = false;
    var objectFilter =
      _.isNil(this.employeeIdFilter) || this.employeeIdFilter <= 0
        ? null
        : this.employeeIdFilter;
    const request = {
      maxResultCount: this.pageSizeConfig,
      skipCount: (this.currentPageConfig - 1) * this.pageSizeConfig,
      clientCode: this.model.id,
      object: objectFilter,
      notificationTypecode: this.notificationTypeCodeFilter,
    };
    await this.$store
      .dispatch({
        type: "client/searchNotificationConfigs",
        data: request,
      })
      .then(() => {
        this.listConfig = this.$store.state.client.listConfig;
      });
  }

  pageChangeConfig(page: number) {
    this.$store.commit("client/setCurrentPageConfig", page);
    this.searchNotificationConfig();
  }
  pagesizeChangeConfig(pagesize: number) {
    this.$store.commit("client/setPageSizeConfig", pagesize);
    this.searchNotificationConfig();
  }

  get pageSizeConfig() {
    return this.$store.state.client.pageSizeConfig;
  }
  get totalCountConfig() {
    return this.$store.state.client.totalCountConfig;
  }
  get currentPageConfig() {
    return this.$store.state.client.currentPageConfig;
  }

  get loading() {
    return this.$store.state.client.loading;
  }

  columnsConfig = [
    {
      title: this.L("Order"),
      width: 70,
      slot: "order",
    },
    {
      title: this.L("Employee"),
      key: "objectName",
    },
    {
      title: "Đối tượng",
      key: "notificationTypeName",
    },
    {
      title: this.L("Action"),
      slot: "action",
      renderHeader: (h: any, params: any) => {
        return h("div", [
          h("span", Util.L("Action")),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
                class: "ivu-icon",
              },
              style: {
                marginRight: "5px",
                marginLeft: "5px",
              },
              on: {
                click: () => {
                  this.onDeleteAllConfig();
                },
              },
            },
            "Xóa tất cả"
          ),
        ]);
      },
    },
  ];
}
